import { render, staticRenderFns } from "./Hamburguesas.vue?vue&type=template&id=d536a0a0&scoped=true&"
import script from "./Hamburguesas.vue?vue&type=script&lang=js&"
export * from "./Hamburguesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d536a0a0",
  null
  
)

export default component.exports